
import { BasicButton } from "@goodgamestudios/asset-globals";

import { BasicUserEvent, GGSCountryController, BrowserUtil } from "@goodgamestudios/core";
import { TimeStringHelper } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { SupportUtil } from "@goodgamestudios/core";
import { MovieClipHelper } from "@goodgamestudios/core";
import { CommandController } from "@goodgamestudios/core";
import { BasicController } from "@goodgamestudios/core";
import { BasicStandardYesNoDialogProperties } from "@goodgamestudios/core";
import { BasicRegisterDialogProperties } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { BasicDialogHandler } from "@goodgamestudios/core";

import { ExternalInterface } from "@goodgamestudios/createjs-utilities";
import { Timer } from "@goodgamestudios/createjs-utilities";

import { int } from "@goodgamestudios/math-utilities";

import { getLogger } from "@goodgamestudios/logger";

import { Poker2Constants } from "../../constants/Poker2Constants";
import { SFConstants } from "../../constants/SFConstants";
import { Balancing } from "../../constants/shared/Balancing";
import { Constants } from "../../constants/shared/Constants";
import { Poker2AntiCheatEvent } from "../../event/Poker2AntiCheatEvent";
import { Poker2DialogEvent } from "../../event/Poker2DialogEvent";
import { Poker2LobbyDataEvent } from "../../event/Poker2LobbyDataEvent";
import { Poker2OnTableEvent } from "../../event/Poker2OnTableEvent";
import { Poker2RankingDataEvent } from "../../event/Poker2RankingDataEvent";
import { Poker2TournamentDataEvent } from "../../event/Poker2TournamentDataEvent";
import { Poker2TutorialEvent } from "../../event/Poker2TutorialEvent";
import { Poker2UserEvent } from "../../event/Poker2UserEvent";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2FeedbackDialogProperties } from "../dialogs/Poker2FeedbackDialogProperties";
import { Poker2ProfilDialogProperties } from "../dialogs/Poker2ProfilDialogProperties";
import { Poker2RankingDialogProperties } from "../dialogs/ranking/Poker2RankingDialogProperties";
import { Poker2TourRegisterProperties } from "../dialogs/tournament/Poker2TourRegisterProperties";
import { PokerTextHelper } from "../helper/PokerTextHelper";
import { ScoreCounter } from "./menuPanel/ScoreCounter";
import { SubMenu } from "./menuPanel/SubMenu";
import { Poker2Panel } from "./Poker2Panel";

import { Linear, TweenLite } from "gsap";
import { NumberStringHelper } from "../../helper/NumberStringHelper";

import { AnimatedMovieClip } from "../../../basic/graphics/animation/AnimatedMovieClip";

import DisplayObject = createjs.DisplayObject;
import MovieClip = createjs.MovieClip;
import MouseEvent = createjs.MouseEvent;
import Rectangle = createjs.Rectangle;

const logger = getLogger("Poker2MenuPanel");

export class Poker2MenuPanel extends Poker2Panel {
    public static NAME: string = "Poker2MenuPanel";
    private seated: boolean = false;
    private static XP_BAR_RANGE: number = 113;
    private animPaymentButton: AnimatedMovieClip;
    private registerTeaserRemindTimer: Timer;

    constructor(disp: DisplayObject) {
        CONSTRUCTOR_HACK;
        super(disp);
    }

    protected init(): void {
        super.init();
        this.controller.addEventListener("changeUserCurrency", this.bindFunction(this.updateUserValues));
        this.controller.addEventListener("changeUserXP", this.bindFunction(this.updateUserXP));
        this.controller.addEventListener("nextTournamentStarttime", this.bindFunction(this.updateNextStartTime));
        this.controller.addEventListener("changeNextTournament", this.bindFunction(this.updateNextTournamentStatus));
        this.controller.addEventListener("menueselection", this.bindFunction(this.onSelectButton));
        this.controller.addEventListener("onswtichscreen", this.bindFunction(this.onSwitchScreen));
        this.controller.addEventListener("emailverificationCompleted", this.bindFunction(this.onMailVerified));
        this.controller.addEventListener("xpbonus", this.bindFunction(this.onRegisterXpBonus));
        this.controller.addEventListener("changelayoutstate", this.bindFunction(this.onChangeLayoutState));

        this._chipsCounter = new ScoreCounter(this.menuPanel.mc_chips);
        this._goldCounter = new ScoreCounter(this.menuPanel.mc_gold);

        this.initTextFields();
        this.updateUserValues();
        this.updateUserXP();
        this.initToolTips();
        this.initAllSublayers();
        this.hideAllSublayer(false);
        this.menuPanel.mc_RegisterTip.visible = false;
        this.animPaymentButton = new AnimatedMovieClip(-1, 1, "ta");
        this.animPaymentButton.processAnimation(this.menuPanel.btn_addmoney, null, false);
        this.animPaymentButton.setFrameRate(24);

        // if (!this.env.loginIsKeyBased && !Poker2Model.userData.emailVerified && !Poker2Model.userData.firstLogin) {
        //     this.menuPanel.mc_RegisterTip.visible = true;
        // }

        this.menuPanel.btn_playnow.mouseChildren = false;
        this.menuPanel.btn_playnow.txt.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;

        this.initTournamentStateDisplay();

        this.menuPanel.mc_xp.gotoAndStop(1);
        this.menuPanel.bg.doCache();
        this.menuPanel.btn_register_tour.uncache();
        this.menuPanel.btn_playtournament.uncache();
        this.menuPanel.btn_registertournament.uncache();
        this.menuPanel.btn_register_tour.txt_title.uncache();
        this.menuPanel.btn_register_tour.txt_time.uncache();
        this.menuPanel.btn_register_tour.txt_titleWide.uncache();
        this.allowCaching = false;

        this.layoutManager.uiAnimationLayer.removeAllChildren();
        this.layoutManager.uiAnimationLayer.addChild(this.menuPanel.btn_addmoney_bonus);
        this.layoutManager.uiAnimationLayer.addChild(this.menuPanel.mc_chips);
        this.layoutManager.uiAnimationLayer.addChild(this.menuPanel.mc_gold);
        this.layoutManager.uiAnimationLayer.addChild(this.menuPanel.mc_xp);
    }

    private initTournamentStateDisplay(): void {
        this.menuPanel.btn_register_tour.txt_time.visible = false;
        this.menuPanel.btn_register_tour.txt_title.visible = false;
        this.menuPanel.btn_register_tour.txt_registered.visible = false;
        this.menuPanel.btn_register_tour.mc_registered.visible = false;
        this.menuPanel.btn_playtournament.visible = false;
        this.menuPanel.btn_registertournament.visible = false;
    }

    private initToolTips(): void {
        this.menuPanel.currencyIconChips.mouseChildren = false;
        this.menuPanel.currencyIconChips.toolTipText = Poker2Model.languageData.getTextById("menu_chips_tooltip");
        this.menuPanel.currencyIconGold.mouseChildren = false;
        this.menuPanel.currencyIconGold.toolTipText = Poker2Model.languageData.getTextById("menu_gold_tooltip");
        this.menuPanel.mc_subhelp.btn_feedback.toolTipText = Poker2Model.languageData.getTextById("menu_btn_feedbackbox");
    }

    private removeRegisterReminder(): void {
        this.menuPanel.mc_RegisterTip.visible = false;
    }

    private onMailVeriCompleted(event: Poker2UserEvent): void {
        this.removeRegisterReminder();
    }

    public show(): void {
        super.show();
        this.controller.addEventListener("sitDown", this.bindFunction(this.onSitDownAtTable));
        this.controller.addEventListener("standUp", this.bindFunction(this.onChangeStandup));
        this.controller.addEventListener("playerLeave", this.bindFunction(this.onPlayerLeave));
        this.controller.addEventListener(BasicUserEvent.REGISTERED, this.bindFunction(this.onRegisteredUser));
        this.controller.addEventListener("paymentbouns", this.bindFunction(this.onStartBonusPayment));

        this.menuPanel.mc_subproperties.btn_soundon.visible = Poker2Model.userData.gamePropertiesVO.playSound == 0;
        this.menuPanel.mc_subproperties.btn_soundoff.visible = Poker2Model.userData.gamePropertiesVO.playSound == 1;

        let panelMtx = this.menuPanel.getMatrix();
        this.layoutManager.uiAnimationLayer.setTransform(panelMtx.tx, panelMtx.ty, panelMtx.a, panelMtx.d);
        if (!this.animPaymentButton.isPlaying()) {
            this.menuPanel.btn_addmoney.play();
            this.menuPanel.btn_addmoney.mc_background.gotoAndStop(1);
        }

        this.menuPanel.btn_lobby.addEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onBtnRollOver));
        this.menuPanel.btn_achievements.addEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onBtnRollOver));
        this.menuPanel.btn_help.addEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onBtnRollOver));
        this.menuPanel.btn_properties.addEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onBtnRollOver));
        this.menuPanel.btn_ranking.addEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onBtnRollOver));
        this.menuPanel.btn_shop.addEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onBtnRollOver));
        this.menuPanel.btn_booster.addEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onBtnRollOver));
        this.menuPanel.btn_facebook.addEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onBtnRollOver));
        this.menuPanel.btn_logout.addEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onBtnRollOver));
        this.menuPanel.btn_bandit.addEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onBtnRollOver));
        this.menuPanel.btn_addmoney.addEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onBtnRollOver));
    }

    private addMoneyOnClick() {
        if(!this.tutorialController.isActive) {
            if (Poker2Model.userData.isGuest()){
                this.layoutManager.showDialog("Poker2RegisterGuestPopUpDialog", new BasicStandardYesNoDialogProperties(Poker2Model.languageData.getTextById("alert_guestlogout_title"), Poker2Model.languageData.getTextById("alert_guest_payment_btn_copy"), this.controller.onStartRegisterDialog, null, null, Poker2Model.languageData.getTextById("generic_login_register")));
            } else {
                this.controller.onClickMoreMoney(null);
            }
        }
    }

    public hide(): void {
        super.hide();
        this.controller.removeEventListener(BasicUserEvent.REGISTERED, this.bindFunction(this.onRegisteredUser));
        this.controller.removeEventListener("sitDown", this.bindFunction(this.onSitDownAtTable));
        this.controller.removeEventListener("standUp", this.bindFunction(this.onChangeStandup));
        this.controller.removeEventListener("playerLeave", this.bindFunction(this.onPlayerLeave));
        this.controller.removeEventListener("paymentbouns", this.bindFunction(this.onStartBonusPayment));

        this.animPaymentButton.stop();
    }

    private onChangeLayoutState(event: Poker2DialogEvent): void {
        if (this.layoutManager.currentState != 10) {
            this.menuPanel.btn_mailverification.visible = false;//!this.env.loginIsKeyBased && !Poker2Model.userData.emailVerified && !Poker2Model.userData.isGuest();
            if (this.layoutManager.currentState == 11) {
                this.menuPanel.btn_playnow.visible = true;
            }
            else {
                this.menuPanel.btn_playnow.visible = false;
            }
        }
        else {
            this.menuPanel.btn_mailverification.visible = false;
            this.menuPanel.btn_playnow.visible = false;
            this.menuPanel.mc_RegisterTip.visible = false;
        }
    }

    private onStartBonusPayment(e: Poker2UserEvent): void {
        this.menuPanel.btn_addmoney_bonus.visible = (Poker2Model.sessionData.activeSpecialOffer && this.env.usePayment);

        if (this.menuPanel.btn_addmoney_bonus.visible) {
            switch (Poker2Model.sessionData.highestSpecialOffer) {
                case 20:
                    this.menuPanel.btn_addmoney_bonus.gotoAndStop(1);
                    break;
                case 50:
                    this.menuPanel.btn_addmoney_bonus.gotoAndStop(2);
                    break;
                case 100:
                    this.menuPanel.btn_addmoney_bonus.gotoAndStop(3);
                    break;
                default:
                    this.menuPanel.btn_addmoney_bonus.gotoAndStop(1);
            }
        }

        if (!Poker2Model.userData.firstLogin) {
            BasicDialogHandler.getInstance().registerDialogs("PokerPaymentTeaserDialog", null, true, BasicDialogHandler.PRIORITY_MIDDLE);
        }
    }

    private updateNextStartTime(event: Poker2TournamentDataEvent): void {
        var time: string = PokerTextHelper.getCountDownTimeString(event.params[0]);
        this.menuPanel.btn_register_tour.txt_time.text = time;
        this.menuPanel.btn_register_tour.txt_time.visible = true;
        this.menuPanel.btn_register_tour.txt_title.visible = true;
    }

    private updateNextTournamentStatus(event: Poker2TournamentDataEvent): void {
        var params: any[] = (event.params) ? event.params : Poker2Model.tournamentData.tournementData;

        // sanity check
        if (!params) {
            logger.error("updateNextTournamentStatus(), params undefined: " + event.params + " / " + Poker2Model.tournamentData.tournementData);
            return;
        }

        this.displayNextTournamentStatus(params);
    }

    private displayNextTournamentStatus(params: any[]): void {
        // sanity check
        if (!params) {
            logger.error("displayNextTournamentStatus(), params undefined: " + params);
            return;
        }

        var status: number = int(params[0]);
        var name: string = params[4];

        // blue button
        this.menuPanel.btn_registertournament.status = status;
        this.menuPanel.btn_registertournament.id = params[1];
        this.menuPanel.btn_registertournament.chips = params[2];
        this.menuPanel.btn_registertournament.gold = params[3];

        // red button
        this.menuPanel.btn_playtournament.status = status;
        this.menuPanel.btn_playtournament.id = params[1];
        this.menuPanel.btn_playtournament.chips = params[2];
        this.menuPanel.btn_playtournament.gold = params[3];
        this.menuPanel.btn_playtournament.tournamentName = params[4];

        switch (status) {
            case 0:
                // Jetzt angemeldet: menu_btn_tournierregister_join
                // 0
                this.menuPanel.btn_register_tour.txt_title.visible = true;
                this.menuPanel.btn_register_tour.txt_titleWide.visible = false;
                this.menuPanel.btn_register_tour.txt_registered.visible = false;
                this.menuPanel.btn_register_tour.txt_time.visible = true;
                this.menuPanel.btn_registertournament.label = Poker2Model.languageData.getTextById("menu_btn_tournierregister_join");
                this.menuPanel.btn_registertournament.toolTipText = Poker2Model.languageData.getTextById("menu_btn_tournierregister_join_tooltip");
                this.visibleOneButton(2);
                break;

            case 1:
                // Bereits angemeldet: menu_btn_tournierregister_joined
                // 1
                this.menuPanel.btn_register_tour.txt_title.visible = true;
                this.menuPanel.btn_register_tour.txt_titleWide.visible = false;
                this.menuPanel.btn_register_tour.txt_registered.visible = true;
                this.menuPanel.btn_register_tour.txt_time.visible = true;
                this.menuPanel.tooltipArea.toolTipText = Poker2Model.languageData.getTextById("menu_btn_tournierregister_registered_tooltip");
                this.visibleOneButton(3);
                break;

            case 2:
                // Tunier läuft: lobby_tour_active, anschauen?
                // 2
                this.menuPanel.btn_register_tour.txt_title.visible = true;
                this.menuPanel.btn_register_tour.txt_titleWide.visible = false;
                this.menuPanel.btn_register_tour.txt_registered.visible = false;
                this.menuPanel.btn_register_tour.txt_time.visible = true;
                this.menuPanel.btn_registertournament.label = Poker2Model.languageData.getTextById("menu_btn_tournierregister_join");
                this.menuPanel.btn_registertournament.toolTipText = Poker2Model.languageData.getTextById("menu_btn_tournierregister_join_tooltip");
                this.visibleOneButton(2);
                break;

            case 3:
                // Tunier läuft: lobby_tour_active, spielen?
                // 3
                this.menuPanel.btn_register_tour.txt_title.visible = false;
                this.menuPanel.btn_register_tour.txt_titleWide.visible = true;
                this.menuPanel.btn_register_tour.txt_registered.visible = true;
                this.menuPanel.btn_register_tour.txt_time.visible = false;
                this.menuPanel.tooltipArea.toolTipText = Poker2Model.languageData.getTextById("menu_btn_tournierregister_inprogress_tooltip");
                this.visibleOneButton(3);
                // text: tournament runs
                TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.menuPanel.btn_register_tour.txt_titleWide, Poker2Model.languageData.getTextById("dialog_tour_register_title") + " " + Poker2Model.languageData.getTextById("menu_tournament_inprogress"));
                break;

            case 4:
                //Turnier läuft: der Spieler ist aber bereits ausgeschiden
                // 4
                this.menuPanel.btn_register_tour.txt_title.visible = true;
                this.menuPanel.btn_register_tour.txt_titleWide.visible = false;
                this.menuPanel.btn_register_tour.txt_registered.visible = false;
                this.menuPanel.btn_register_tour.txt_time.visible = true;
                this.menuPanel.btn_registertournament.label = Poker2Model.languageData.getTextById("menu_btn_tournierregister_join");
                this.menuPanel.btn_registertournament.toolTipText = Poker2Model.languageData.getTextById("menu_btn_tournierregister_join_tooltip");
                this.visibleOneButton(2);
                break;

            case 5:
                // 5
                this.menuPanel.btn_register_tour.txt_title.visible = false;
                this.menuPanel.btn_register_tour.txt_titleWide.visible = true;
                this.menuPanel.btn_register_tour.txt_time.visible = false;
                this.menuPanel.btn_register_tour.txt_registered.visible = false;
                this.menuPanel.btn_playtournament.toolTipText = Poker2Model.languageData.getTextById("menu_btn_tournierregister_inprogress_tooltip");
                this.menuPanel.btn_playtournament.label = Poker2Model.languageData.getTextById("menu_btn_tournierregister_joinTable");
                this.visibleOneButton(1);

                // text: [tournament name] runs
                TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.menuPanel.btn_register_tour.txt_titleWide, name + " " + Poker2Model.languageData.getTextById("menu_tournament_inprogress"));
                break;

            default:

                logger.error("updateNextTournamentStatus(), unknown player status: " + status + ". Have to be between 0 and 5.");
                break;
        }
        this.menuPanel.btn_register_tour.mc_registered.visible = this.menuPanel.btn_register_tour.txt_registered.visible;
    }

    private visibleOneButton(no: number): void {
        this.menuPanel.btn_playtournament.visible = no == 1;
        this.menuPanel.btn_registertournament.visible = no == 2;
        this.menuPanel.tooltipArea.visible = no == 3;
    }

    private initTextFields(): void {
        TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.menuPanel.btn_register_tour.txt_title, Poker2Model.languageData.getTextById("menu_btn_tournierregister_title"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(8, this.menuPanel.btn_register_tour.txt_registered, Poker2Model.languageData.getTextById("menu_btn_tournierregister_registered"));

        this.menuPanel.btn_achievements.toolTipText = Poker2Model.languageData.getTextById("menu_btn_achievements");
        this.menuPanel.btn_addmoney.toolTipText = Poker2Model.languageData.getTextById("btn_addcurrency");
        this.menuPanel.btn_bandit.toolTipText = Poker2Model.languageData.getTextById("menu_btn_bandit");
        this.menuPanel.btn_booster.toolTipText = Poker2Model.languageData.getTextById("menu_btn_booster");
        this.menuPanel.btn_playnow.txt.text = Poker2Model.languageData.getTextById("generic_login_play");

        if (!this.env.networkNewsByJS) {
            // default
            this.menuPanel.btn_facebook.toolTipText = "Facebook";//Poker2Model.languageData.getTextById("generic_forum");
        }
        else {
            // use 'group' as tooltip e.g. in social networks like meinVZ
            this.menuPanel.btn_facebook.toolTipText = "Facebook";//Poker2Model.languageData.getTextById("generic_group");
        }

        this.menuPanel.mc_subproperties.btn_fullscreen.toolTipText = Poker2Model.languageData.getTextById("menu_btn_fullscreen");
        this.menuPanel.mc_subranking.btn_halloffame.toolTipText = Poker2Model.languageData.getTextById("menu_btn_halloffame");
        this.menuPanel.btn_help.toolTipText = Poker2Model.languageData.getTextById("menu_btn_help");
        this.menuPanel.mc_subshop.btn_inventar.toolTipText = Poker2Model.languageData.getTextById("menu_btn_inventar");
        this.menuPanel.btn_lobby.toolTipText = Poker2Model.languageData.getTextById("menu_btn_lobby");
        this.menuPanel.btn_logout.toolTipText = Poker2Model.languageData.getTextById("menu_btn_logout");
        this.menuPanel.btn_properties.toolTipText = Poker2Model.languageData.getTextById("menu_btn_properties");
        this.menuPanel.btn_ranking.toolTipText = Poker2Model.languageData.getTextById("menu_btn_ranking");
        this.menuPanel.btn_shop.toolTipText = Poker2Model.languageData.getTextById("menu_btn_shop");
        this.menuPanel.mc_subproperties.btn_soundon.toolTipText = Poker2Model.languageData.getTextById("menu_btn_sound");
        this.menuPanel.mc_subproperties.btn_soundoff.toolTipText = Poker2Model.languageData.getTextById("menu_btn_sound");
        this.menuPanel.mc_subachievement.btn_statistics.toolTipText = Poker2Model.languageData.getTextById("menu_btn_statistics");
        this.menuPanel.mc_subhelp.btn_support.toolTipText = Poker2Model.languageData.getTextById("menu_btn_support");
        this.menuPanel.btn_standup.toolTipText = Poker2Model.languageData.getTextById("menu_btn_standup");
        this.menuPanel.mc_sublobby.btn_tunier.toolTipText = Poker2Model.languageData.getTextById("menu_btn_tunier");
        this.menuPanel.mc_sublobby.btn_sitngo.toolTipText = Poker2Model.languageData.getTextById("lobby_sitngo_title");
        this.menuPanel.mc_subranking.btn_tunierranking.toolTipText = Poker2Model.languageData.getTextById("menu_btn_tunierranking");
        this.menuPanel.mc_subhelp.btn_tutorial.toolTipText = Poker2Model.languageData.getTextById("menu_btn_tutorial");
        this.menuPanel.mcTooltipLvl.mouseChildren = false;
        this.menuPanel.mcTooltipLvl.toolTipText = Poker2Model.languageData.getTextById("dialog_ranking_level");
        this.menuPanel.btn_mailverification.toolTipText = Poker2Model.languageData.getTextById("menu_btn_verifyemail");
        this.menuPanel.mc_xp.txt_level.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;

        this.menuPanel.btn_logout.visible = !this.env.loginIsKeyBased;
        this.menuPanel.mc_subproperties.btn_fullscreen.enableButton = this.env.allowedfullscreen;
        this.menuPanel.btn_mailverification.visible = !this.env.loginIsKeyBased && !Poker2Model.userData.emailVerified && !Poker2Model.userData.isGuest();
        this.menuPanel.btn_register.visible = Poker2Model.userData.isGuest();

        this.menuPanel.btn_addmoney_bonus.visible = (Poker2Model.sessionData.activeSpecialOffer && this.env.usePayment);
        this.menuPanel.mc_xpbonus.visible = Poker2Model.sessionData.activeSpecialOfferXP;
        this.menuPanel.mc_tooltipXp.mouseChildren = false;

        this.menuPanel.btn_addmoney.enableButton = this.env.usePayment;
        this.menuPanel.btn_facebook.enableButton = this.env.useexternallinks;
        this.menuPanel.mc_subhelp.btn_support.enableButton = this.env.useexternallinks;

        this.menuPanel.btn_lobby.visible = !this.seated;
        this.menuPanel.btn_standup.visible = this.seated;

        this.menuPanel.mc_RegisterTip.txt_copy.text = Poker2Model.languageData.getTextById("menu_btn_verifyemail_tt");
        this.menuPanel.mc_RegisterTip.mc_reward.txt_chips.text = String(5000);

        if (Poker2Model.userData.isGuest()) {
            this.menuPanel.btn_register_tour.txt_registered.visible = false;
            this.menuPanel.btn_register_tour.mc_registered.visible = false;
            this.menuPanel.btn_registertournament.label = Poker2Model.languageData.getTextById("menu_btn_tournierregister_join");
            this.visibleOneButton(2);
        }
    }

    private onRegisteredUser(event: BasicUserEvent): void {
        this.menuPanel.btn_register.visible = false;
        this.menuPanel.btn_mailverification.visible = !this.env.loginIsKeyBased && !Poker2Model.userData.emailVerified;
        this.standUp();
    }

    private onMailVerified(event: Poker2UserEvent): void {
        this.menuPanel.btn_mailverification.visible = false;
        this.removeRegisterReminder();
    }

    public destroy(): void {
        this.controller.removeEventListener("changeUserCurrency", this.bindFunction(this.updateUserValues));
        this.controller.removeEventListener("changeUserXP", this.bindFunction(this.updateUserXP));
        this.controller.removeEventListener("nextTournamentStarttime", this.bindFunction(this.updateNextStartTime));
        this.controller.removeEventListener("changeNextTournament", this.bindFunction(this.updateNextTournamentStatus));
        this.controller.removeEventListener("menueselection", this.bindFunction(this.onSelectButton));
        this.controller.removeEventListener("onswtichscreen", this.bindFunction(this.onSwitchScreen));
        this.controller.removeEventListener("emailverificationCompleted", this.bindFunction(this.onMailVerified));
        this.controller.removeEventListener("xpbonus", this.bindFunction(this.onRegisterXpBonus));
        this.controller.removeEventListener("changelayoutstate", this.bindFunction(this.onChangeLayoutState));

        this.animPaymentButton.stop();
        this.animPaymentButton = null;
        this.removeRegisterReminder();
        super.destroy();
    }

    private updateUserValues(event: Poker2UserEvent = null): void {
        this._chipsCounter.update(Poker2Model.userData.userCash);
        this._goldCounter.update(Poker2Model.userData.userGold);
    }

    private updateUserXP(event: Poker2UserEvent = null): void {
        this.menuPanel.mc_xp.txt_level.text = String(Poker2Model.userData.userLevel);
        this.menuPanel.mc_xp.mc_xpbar.xpbar.width = Poker2MenuPanel.XP_BAR_RANGE * Poker2Model.userData.xpPercentToNextLevel / 100;
        this.menuPanel.mc_tooltipXp.toolTipText = Poker2Model.languageData.getTextById("menu_xp_tooltip", [NumberStringHelper.groupString(Poker2Model.userData.userXPtoNextLevel - Poker2Model.userData.userXP, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData))]);
        this.menuPanel.mc_xp.gotoAndPlay(1);
    }

    private onRegisterXpBonus(event: Poker2UserEvent): void {

        this.menuPanel.mc_xpbonus.visible = Poker2Model.sessionData.activeSpecialOfferXP;

        if (Poker2Model.sessionData.activeSpecialOfferXP) {
            this.menuPanel.mc_xpbonus.txt_offer_value.text = event.params[0];
            this.menuPanel.mc_xpbonus.toolTipText = Poker2Model.languageData.getTextById("generic_payment_discount_time", [TimeStringHelper.getTimeToString(Poker2Model.sessionData.specialOffer_XP_timeleft, TimeStringHelper.TWO_TIME_FORMAT, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData))]);
        }
    }

    private updateBonusXPtooltip(): void {
        if (Poker2Model.sessionData.activeSpecialOfferXP) {
            var timeleft: number = int((Poker2Model.sessionData.specialOffer_XP_timeleft * 1000 - Date.now()) / 1000);
            var time: string = TimeStringHelper.getTimeToString(timeleft, TimeStringHelper.TWO_TIME_FORMAT, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));

            if (timeleft > 0) {
                this.menuPanel.mc_xpbonus.toolTipText = Poker2Model.languageData.getTextById("generic_payment_discount_time", [time]);
            }
            else {
                this.menuPanel.mc_xpbonus.visible = false;
            }
        }
    }

    protected onRollOver(event: MouseEvent): void {
        super.onRollOver(event);
        this.layoutManager.gameStage.tickEnabled = false;
        this.layoutManager.onMenu = true;
    }

    private onBtnRollOver(event: MouseEvent): void {
        switch (event.target) {
            case this.menuPanel.btn_lobby:
                this.showSubLayer(this.menuPanel.mc_sublobby);
                break;
            case this.menuPanel.btn_achievements:
                this.showSubLayer(this.menuPanel.mc_subachievement);
                break;
            case this.menuPanel.btn_help:
                this.showSubLayer(this.menuPanel.mc_subhelp);
                break;
            case this.menuPanel.btn_properties:
                this.showSubLayer(this.menuPanel.mc_subproperties);
                break;
            case this.menuPanel.btn_ranking:
                this.showSubLayer(this.menuPanel.mc_subranking);
                break;
            case this.menuPanel.btn_shop:
                this.showSubLayer(this.menuPanel.mc_subshop);
                break;

            default:
                this.hideLastSublayer();
                break;
        }

        this.updateCache();
    }

    protected onRollOut(event: MouseEvent): void {
        super.onRollOut(event);
        this.hideLastSublayer();
        this.layoutManager.gameStage.tickEnabled = true;
        this.layoutManager.onMenu = false;
    }

    protected onMouseOver(event: MouseEvent): void {
        super.onMouseOver(event);
        this.updateBonusXPtooltip();

        // if (!this.env.loginIsKeyBased && !Poker2Model.userData.emailVerified && !this.menuPanel.mc_RegisterTip.visible) {
        //     switch (event.target) {
        //         case this.menuPanel.btn_mailverification:
        //             this.menuPanel.mc_RegisterTip.visible = false;
        //             TweenLite.fromTo(this.menuPanel.mc_RegisterTip, .2, { scaleX: 0 }, { scaleX: 1, ease: Linear.easeIn });
        //             TweenLite.fromTo(this.menuPanel.mc_RegisterTip, .2, { scaleY: 0 }, { scaleY: 1, ease: Linear.easeIn });
        //             break;
        //     }
        // }
        // else if (event.target.parent == this.menuPanel.mc_RegisterTip) {
        //     this.menuPanel.mc_RegisterTip.visible = false;
        // }
    }

    protected onMouseOut(event: MouseEvent): void {
        super.onMouseOut(event);

        // if (!this.env.loginIsKeyBased && !Poker2Model.userData.emailVerified)
        //     switch (event.target) {
        //         case this.menuPanel.btn_mailverification:
        //             TweenLite.fromTo(this.menuPanel.mc_RegisterTip, .2, { scaleX: 1 }, { scaleX: 0, ease: Linear.easeIn, onComplete: this.bindFunction(function makeInvisible(): void { this.menuPanel.mc_RegisterTip.visible = false; }) });
        //             TweenLite.fromTo(this.menuPanel.mc_RegisterTip, .2, { scaleY: 1 }, { scaleY: 0, ease: Linear.easeIn });
        //             break;
        //     }
    }

    private hideAllSublayer(doTween: boolean = true): void {
        var i: number = 0;
        var len: number = int(this._sublayers.length);
        for (i = 0; i < len; ++i) {
            // set values
            this.hideSubLayer(this._sublayers[i], doTween);
        }
    }

    private initAllSublayers(): void {
        this._sublayers = [this.menuPanel.mc_subachievement, this.menuPanel.mc_subhelp, this.menuPanel.mc_sublobby, this.menuPanel.mc_subproperties, this.menuPanel.mc_subranking, this.menuPanel.mc_subshop];

        var i: number = 0;
        var len: number = int(this._sublayers.length);
        for (i = 0; i < len; ++i) {
            // set values
            this._sublayers[i].visibleY = this._sublayers[i].y;
            this._sublayers[i].invisibleY = -this._sublayers[i].height;
            this._sublayers[i].subMenu = new SubMenu(this._sublayers[i]);
        }
    }

    private _sublayers: any[];
    private _lastSublayer: MovieClip;
    private _chipsCounter: ScoreCounter;
    private _goldCounter: ScoreCounter;

    private showSubLayer(sublayer: MovieClip): void {
        this.hideLastSublayer(sublayer);
        sublayer.subMenu.show();
    }

    private hideLastSublayer(sublayer: MovieClip = null): void {
        if (this._lastSublayer) {
            this._lastSublayer.subMenu.hide();
        }

        this._lastSublayer = sublayer;
    }

    private hideSubLayer(sublayer: MovieClip, doTween: boolean = true): void {
        if (!doTween) {
            sublayer.subMenu.y = sublayer.invisibleY;
            return;
        }

        sublayer.subMenu.hide();
    }

    private onSelectButton(event: Poker2DialogEvent): void {
        var button: BasicButton;

        switch (event.params[0]) {
            case "Poker2ProfilDialog" + "_" + 1:
                button = this.menuPanel.btn_achievements;
                break;
            case "Poker2ProfilDialog" + "_" + 2:
                button = this.menuPanel.mc_subachievement.btn_statistics;
                break;
            case "Poker2AchivementStatsScreen" + "_" + 1:
                button = this.menuPanel.btn_achievements;
                break;
            case "Poker2AchivementStatsScreen" + "_" + 2:
                button = this.menuPanel.mc_subachievement.btn_statistics;
                break;
            case "Poker2RankingDialog" + "_" + 3:
                button = this.menuPanel.btn_ranking;
                break;
            case "Poker2RankingDialog" + "_" + 4:
                button = this.menuPanel.mc_subranking.btn_tunierranking;
                break;
            case "Poker2RankingDialog" + "_" + 5:
                button = this.menuPanel.mc_subranking.btn_halloffame;
                break;
            case "Poker2RankingScreen" + "_" + 3:
                button = this.menuPanel.btn_ranking;
                break;
            case "Poker2RankingScreen" + "_" + 4:
                button = this.menuPanel.mc_subranking.btn_tunierranking;
                break;
            case "Poker2RankingScreen" + "_" + 5:
                button = this.menuPanel.mc_subranking.btn_halloffame;
                break;
            case "Poker2LobbyTablesScreen":
                button = this.menuPanel.btn_lobby;
                break;
            case "Poker2TournamentScreen":
                button = this.menuPanel.mc_sublobby.btn_tunier;
                break;
            case "Poker2ShopScreen" + "_" + "stateShop":
                button = this.menuPanel.btn_shop;
                break;
            case "Poker2ShopScreen" + "_" + "stateInventory":
                button = this.menuPanel.mc_subshop.btn_inventar;
                break;
            case "Poker2BoosterBuyDialog":
                button = this.menuPanel.btn_booster;
                break;
            case "Poker2BoosterScreen":
                button = this.menuPanel.btn_booster;
                break;
            case "Poker2BanditDialog":
                button = this.menuPanel.btn_bandit;
                break;
        }

        if (int(event.params[1]) == 1)
            button.selected();
        else
            button.deselected();

        this.updateCache();
    }

    protected onTutorialEvent(event: Poker2TutorialEvent): void {
        var rect: Rectangle;

        if (this.tutorialController.isActive) {
            switch (this.tutorialController.tutorialState) {
                case "tut_step5_buyIn":
                    this.layoutManager.tutPanel.hideSpotlight();
                    break;
                case "tut_step15_oliverCheck":
                    this.layoutManager.tutPanel.hideSpotlight();
                    break;
                case "tut_step15_oliverCheck":
                    this.layoutManager.tutPanel.hideSpotlight();
                    break;
                case "tut_step19_oliverCheck":
                    this.layoutManager.tutPanel.hideSpotlight();
                    break;
                case "tut_step35_xpBar":
                    rect = new Rectangle(65, 25, 60, 16);
                    this.layoutManager.tutPanel.showSpotlight(rect);
                    break;
                case "tut_step36_levelUp":
                    if (Poker2Model.userData.tutorialCase == 1) {
                        // a)
                        rect = new Rectangle(33, 25, 16, 16);
                        this.layoutManager.tutPanel.showSpotlight(rect);
                    }
                    else if (Poker2Model.userData.tutorialCase == 0) {
                        // b)
                        this.layoutManager.tutPanel.hideSpotlight();
                    }
                    break;
                case "tut_step37_standUp":
                    this.layoutManager.tutPanel.showTutorialArrow(this.menuPanel.btn_standup, true, true);
                    this.layoutManager.tutPanel.hideSpotlight();
                    // rect = new Rectangle(337,15,35,35);
                    // layoutManager.tutPanel.showSpotlight(rect);
                    break;
                case "tut_step38_leaveTable":
                    this.layoutManager.tutPanel.showTutorialArrow(this.menuPanel.btn_lobby, true, true);
                    // rect = new Rectangle(337,15,35,35);
                    // layoutManager.tutPanel.showSpotlight(rect);
                    break;
                case "tut_step39_congratulation_copy":
                    this.layoutManager.tutPanel.hideSpotlight();
                    break;
            }
            this.updateCache();
            return;
        }
    }

    protected onClick(event: MouseEvent): void {
        if (this.isLocked)
            return;

        if (instanceOfClass(event.target, "TextField"))
            return;

        if (this.tutorialController.isActive) {
            switch (event.target) {
                case this.menuPanel.btn_addmoney:
                case this.menuPanel.btn_facebook:
                case this.menuPanel.mc_subhelp.btn_support:
                case this.menuPanel.mc_subproperties.btn_soundoff:
                case this.menuPanel.mc_subproperties.btn_soundon:
                    // ignore tutorial
                    break;
                default:
                    // tutorial work
                    switch (this.tutorialController.tutorialState) {
                        case "tut_step37_standUp":
                            if (event.target == this.menuPanel.btn_standup) {
                                this.standUp();
                                this.tutorialController.nextStep();
                            }
                            break;
                        case "tut_step38_leaveTable":
                            if (event.target == this.menuPanel.btn_lobby) {
                                this.layoutManager.state = 11;
                                this.tutorialController.nextStep();
                            }
                            break;
                    }
                    return;
            }
        }

        super.onClick(event);

        if (!event.target.enabled)
            return;
        var paramObject: any;

        this.layoutManager.gameStage.tickEnabled = true;

        switch (event.target) {
            case this.menuPanel.btn_playnow:
                this.playNow();
                break;
            case this.menuPanel.btn_addmoney:
                if (Poker2Model.userData.isGuest())
                    this.layoutManager.showDialog("Poker2RegisterGuestPopUpDialog", new BasicStandardYesNoDialogProperties(Poker2Model.languageData.getTextById("alert_guestlogout_title"), Poker2Model.languageData.getTextById("alert_guest_payment_btn_copy"), this.controller.onStartRegisterDialog, null, null, Poker2Model.languageData.getTextById("generic_login_register")));
                else
                    this.controller.onClickMoreMoney(null);
                break;
            case this.menuPanel.btn_mailverification:
                this.layoutManager.showDialog("Poker2MailVerificationDialog");
                break;
            case this.menuPanel.btn_standup:
                this.standUpFromTable();
                break;
            case this.menuPanel.btn_lobby:
                this.layoutManager.state = 11;
                break;
            case this.menuPanel.mc_sublobby.btn_tunier:
                if (Poker2Model.userData.isGuest())
                    this.layoutManager.showDialog("Poker2RegisterGuestPopUpDialog", new BasicStandardYesNoDialogProperties(Poker2Model.languageData.getTextById("alert_guestlogout_title"), Poker2Model.languageData.getTextById("alert_guesttournament_copy"), this.controller.onStartRegisterDialog, null, null, Poker2Model.languageData.getTextById("generic_login_register")));
                else {
                    BasicModel.smartfoxClient.sendMessage("jli", [JSON.stringify({ sort: 0 })]);
                    this.layoutManager.state = 14;
                }
                break;
            case this.menuPanel.mc_sublobby.btn_sitngo:
                BasicModel.smartfoxClient.sendMessage("sli", [JSON.stringify({ sort: 0 })]);
                this.layoutManager.state = 17;
                break;
            case this.menuPanel.btn_achievements:
                this.getAchievementStats();
                break;
            case this.menuPanel.mc_subachievement.btn_statistics:
                this.getUserStats();
                break;
            case this.menuPanel.btn_ranking:
                if (this.layoutManager.currentState != 10) {
                    this.layoutManager.state = 18;
                    this.controller.dispatchEvent(new Poker2RankingDataEvent("changeRankingTab", [3]));
                }
                else {
                    this.layoutManager.showDialog("Poker2RankingDialog", new Poker2RankingDialogProperties(3));
                }
                break;
            case this.menuPanel.mc_subranking.btn_tunierranking:
                if (this.layoutManager.currentState != 10) {
                    this.layoutManager.state = 18;
                    this.controller.dispatchEvent(new Poker2RankingDataEvent("changeRankingTab", [4]));
                }
                else {
                    this.layoutManager.showDialog("Poker2RankingDialog", new Poker2RankingDialogProperties(4));
                }
                break;
            case this.menuPanel.mc_subranking.btn_halloffame:
                if (this.layoutManager.currentState != 10) {
                    this.layoutManager.state = 18;
                    this.controller.dispatchEvent(new Poker2RankingDataEvent("changeRankingTab", [5]));
                }
                else {
                    this.layoutManager.showDialog("Poker2RankingDialog", new Poker2RankingDialogProperties(5));
                }
                break;
            case this.menuPanel.btn_shop:
                if (this.layoutManager.currentState == 10 && this.seated)
                    this.layoutManager.showDialog(Poker2StandardYesNoDialog.NAME, new BasicStandardYesNoDialogProperties(Poker2Model.languageData.getTextById("generic_alert_watchout"), Poker2Model.languageData.getTextById("alert_leave_table"), this.bindFunction(this.switchToShop)));
                else
                    this.switchToShop(null);
                break;
            case this.menuPanel.btn_register:
                var registerProperties: BasicRegisterDialogProperties = new BasicRegisterDialogProperties();
                registerProperties.username = Poker2Model.userData.userName;
                this.layoutManager.showDialog(Poker2RegisterDialog.NAME, registerProperties);
                break;
            case this.menuPanel.mc_subshop.btn_inventar:
                if (this.layoutManager.currentState == 10 && this.seated)
                    this.layoutManager.showDialog(Poker2StandardYesNoDialog.NAME, new BasicStandardYesNoDialogProperties(Poker2Model.languageData.getTextById("generic_alert_watchout"), Poker2Model.languageData.getTextById("alert_leave_table"), this.bindFunction(this.switchToInventar)));
                else
                    this.switchToInventar(null);
                break;
            case this.menuPanel.btn_booster:
                if (this.layoutManager.currentState != 10) {
                    this.layoutManager.state = 20;
                }
                else {
                    this.layoutManager.showDialog("Poker2BoosterBuyDialog");
                }
                break;
            case this.menuPanel.btn_bandit:
                this.layoutManager.showDialog("Poker2BanditDialog");
                break;
            case this.menuPanel.btn_facebook:
                this.goSimpleFacebookForum();
                break;
            case this.menuPanel.btn_logout:
                if (Poker2Model.userData.isGuest()) {
                    var logoutFunction: Function = CommandController.instance.getExecFunctionFromCommand(BasicController.COMMAND_LOGOUT);
                    this.layoutManager.showDialog("Poker2RegisterGuestPopUpDialog", new BasicStandardYesNoDialogProperties(Poker2Model.languageData.getTextById("alert_guestlogout_title"), Poker2Model.languageData.getTextById("alert_guestlogout_copy"), this.controller.onStartRegisterDialog, logoutFunction, null, Poker2Model.languageData.getTextById("generic_login_register"), Poker2Model.languageData.getTextById("generic_logout")));
                }
                else {
                    this.layoutManager.removeTutorialPanel();
                    this.controller.dispatchEvent(new Poker2AntiCheatEvent("antiCheatRemoveConnection"));
                    CommandController.instance.executeCommand(BasicController.COMMAND_LOGOUT);
                }
                break;
            case this.menuPanel.btn_help:
                this.layoutManager.showDialog("Poker2HelpDialog");
                break;
            case this.menuPanel.mc_subhelp.btn_tutorial:
                if (this.layoutManager.currentState == 10 && this.seated) {
                    this.layoutManager.showDialog(Poker2StandardYesNoDialog.NAME, new BasicStandardYesNoDialogProperties(Poker2Model.languageData.getTextById("generic_alert_watchout"), Poker2Model.languageData.getTextById("alert_leave_table"), this.bindFunction(this.switchToTutorial)));
                }
                else
                    this.switchToTutorial();
                break;
            case this.menuPanel.mc_subhelp.btn_support:
                this.mailSupport();
                break;
            case this.menuPanel.btn_properties:
                this.layoutManager.showDialog("Poker2OptionDialog");
                break;
            case this.menuPanel.mc_subproperties.btn_fullscreen:
                this.layoutManager.toggleFullscreen();
                break;
            case this.menuPanel.mc_subproperties.btn_soundoff:
                Poker2Model.userData.gamePropertiesVO.playSound = 0;
                this.controller.soundController.muteAll();
                this.menuPanel.mc_subproperties.btn_soundoff.visible = false;
                this.menuPanel.mc_subproperties.btn_soundon.visible = true;
                paramObject = { showTT: Poker2Model.userData.gamePropertiesVO.showTooltip, ignoreBuddy: Poker2Model.userData.gamePropertiesVO.ignoreBuddyRequest, playSound: Poker2Model.userData.gamePropertiesVO.playSound };
                BasicModel.smartfoxClient.sendMessage("gpc", [JSON.stringify(paramObject)]);
                break;
            case this.menuPanel.mc_subproperties.btn_soundon:
                Poker2Model.userData.gamePropertiesVO.playSound = 1;
                this.controller.soundController.unMuteAll();
                this.menuPanel.mc_subproperties.btn_soundon.visible = false;
                this.menuPanel.mc_subproperties.btn_soundoff.visible = true;
                paramObject = { showTT: Poker2Model.userData.gamePropertiesVO.showTooltip, ignoreBuddy: Poker2Model.userData.gamePropertiesVO.ignoreBuddyRequest, playSound: Poker2Model.userData.gamePropertiesVO.playSound };
                BasicModel.smartfoxClient.sendMessage("gpc", [JSON.stringify(paramObject)]);
                break;
            case this.menuPanel.btn_registertournament:
            case this.menuPanel.btn_playtournament:
                this.onNextTournamentStatus(event.target.status, event.target.id, event.target.chips, event.target.gold, this.menuPanel.btn_playtournament.tournamentName);
                break;
            case this.menuPanel.mc_subhelp.btn_feedback:
                this.layoutManager.showDialog("PokerFeedbackDialog", new Poker2FeedbackDialogProperties());
        }
    }

    private mailSupport(): void {
        SupportUtil.navigateToSupport(BasicModel.instanceProxy.selectedInstanceVO.instanceId, this.env.versionInformation.versionText, Poker2Model.userData.userName, Poker2Model.userData.playerID, Poker2Model.userData.userID, GGSCountryController.instance.currentCountry.ggsLanguageCode);
    }

    private goGroup(): void {
        if (!ExternalInterface.available)
            return;

        try {
            ExternalInterface.call("requestGroup");
        }
        catch (error) {
        }
    }

    private goNews(): void {
        if (this.env.networkNewsByJS) {
            this.goGroup();
        }
        else if (this.env.useexternallinks) {
            CommandController.instance.executeCommand(BasicController.COMMAND_OPEN_FORUM);
        }
    }

    private goSimpleFacebookForum() {
        BrowserUtil.executeNavigateToURL("https://www.facebook.com/GGSPoker", "_blank");
    }

    private switchToShop(params: any[]): void {
        if (this.seated)
            this.standUpFromTable();
        this.layoutManager.state = 12;
        this.controller.dispatchEvent(new Poker2UserEvent("changeShopState", ["stateShop"]));
    }

    private switchToInventar(params: any[]): void {
        if (this.seated)
            this.standUpFromTable();
        this.layoutManager.state = 13;
        this.controller.dispatchEvent(new Poker2UserEvent("changeShopState", ["stateInventory"]));
    }

    private switchToTutorial(params: any[] = null): void {
        if (this.seated)
            this.standUpFromTable();
        this.tutorialController.startTutorial(new Library.PokerTutorial.TutorialArrow());
    }

    private onSwitchScreen(event: Poker2DialogEvent): void {
        if (this.layoutManager.currentState == 10 && this.seated)
            this.layoutManager.showDialog(Poker2StandardYesNoDialog.NAME, new BasicStandardYesNoDialogProperties(Poker2Model.languageData.getTextById("generic_alert_watchout"), Poker2Model.languageData.getTextById("alert_leave_table"), this.bindFunction(this.switchToShop)));
        else
            this.switchToShop(null);
    }

    private onNextTournamentStatus(status: number, tournamentId: number, chips: number, gold: number, tournamentName: string): void {
        switch (status) {
            case 0: //0
                this.layoutManager.showDialog("Poker2TourRegisterDialog", new Poker2TourRegisterProperties(tournamentId, tournamentName, chips, gold, this.bindFunction(this.register)));
                break;
            case 1: //1
                break;
            case 2: //2
                this.layoutManager.showDialog("Poker2TourRegisterDialog", new Poker2TourRegisterProperties(tournamentId, tournamentName, chips, gold, this.bindFunction(this.register)));
                break;
            case 3: //3
                break;
            case 4: //4
                this.layoutManager.showDialog("Poker2TourRegisterDialog", new Poker2TourRegisterProperties(tournamentId, tournamentName, chips, gold, this.bindFunction(this.register)));
                break;
            case 5: //5
                this.playTournament(tournamentId);
                break;
        }
    }

    // Fuer eein Turnier registrieren oder abmelden, der Sever bestimmt das
    private register(tournamentId: number): void {
        var paramObject: any = { id: tournamentId };
        BasicModel.smartfoxClient.sendMessage("jre", [JSON.stringify(paramObject)]);
    }

    private playTournament(tournamentId: number): void {
        var paramObject: any = { id: tournamentId };
        BasicModel.smartfoxClient.sendMessage("jjn", [JSON.stringify(paramObject)]);
    }

    private standUpFromTable(): void {
        BasicModel.smartfoxClient.sendMessage("gsu", []);

        if (instanceOfClass(Poker2Model.onTableData.currentTable.gameType, "TournamentTypeAbstract")) {
            this.standUp();
        }
    }

    private getUserStats(): void {
        var paramObject: any = { id: Poker2Model.userData.playerID };
        BasicModel.smartfoxClient.sendMessage("gpp", [JSON.stringify(paramObject)]);
    }

    private getAchievementStats(): void {
        var paramObject: any = { id: Poker2Model.userData.playerID };
        BasicModel.smartfoxClient.sendMessage("ali", [JSON.stringify(paramObject)]);
    }

    private onSitDownAtTable(event: Poker2OnTableEvent): void {
        this.sitDown();
    }

    private onChangeStandup(event: Poker2OnTableEvent): void {
        this.standUp();
    }

    private onPlayerLeave(event: Poker2OnTableEvent): void {
        if (event.params[0] == Poker2Model.onTableData.myPlayerPos)
            this.standUp();
    }

    private sitDown(): void {
        this.seated = true;
        this.menuPanel.btn_lobby.visible = !this.seated;
        this.menuPanel.btn_standup.visible = this.seated;
    }

    private standUp(): void {
        this.seated = false;
        this.menuPanel.btn_lobby.visible = !this.seated;
        this.menuPanel.btn_standup.visible = this.seated;
    }

    private playNow(): void {
        this.controller.dispatchEvent(new Poker2LobbyDataEvent("playNow"));
    }

    protected get menuPanel(): Library.PokerMenuPanel.MenuPanel {
        return this.disp as Library.PokerMenuPanel.MenuPanel;
    }
}
import { Poker2TutorialController } from "../../controller/Poker2TutorialController";
import { Poker2BanditDialog } from "../dialogs/bandit/Poker2BanditDialog";
import { Poker2BoosterBuyDialog } from "../dialogs/booster/Poker2BoosterBuyDialog";
import { Poker2MailVerificationDialog } from "../dialogs/mailverification/Poker2MailVerificationDialog";
import { Poker2FeedbackDialog } from "../dialogs/Poker2FeedbackDialog";
import { Poker2HelpDialog } from "../dialogs/Poker2HelpDialog";
import { Poker2OptionDialog } from "../dialogs/Poker2OptionDialog";
import { Poker2PaymentTeaserDialog } from "../dialogs/Poker2PaymentTeaserDialog";
import { Poker2ProfilDialog } from "../dialogs/Poker2ProfilDialog";
import { Poker2StandardYesNoDialog } from "../dialogs/Poker2StandardYesNoDialog";
import { Poker2RankingDialog } from "../dialogs/ranking/Poker2RankingDialog";
import { Poker2RegisterDialog } from "../dialogs/registration/Poker2RegisterDialog";
import { Poker2RegisterGuestPopUpDialog } from "../dialogs/registration/Poker2RegisterGuestPopUpDialog";
import { Poker2TourRegisterDialog } from "../dialogs/tournament/Poker2TourRegisterDialog";
import { Poker2LayoutManager } from "../Poker2LayoutManager";
import { Poker2AchivementStatsScreen } from "../screens/Poker2AchivementStatsScreen";
import { Poker2BoosterScreen } from "../screens/Poker2BoosterScreen";
import { Poker2LobbyTablesScreen } from "../screens/Poker2LobbyTablesScreen";
import { Poker2RankingScreen } from "../screens/Poker2RankingScreen";
import { Poker2ShopScreen } from "../screens/Poker2ShopScreen";
import { Poker2TournamentScreen } from "../screens/Poker2TournamentScreen";

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
